import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import ERROR from 'errors/errorids';
import StickyHeader from '../../components/StickyHeader/StickyHeader';
import RolesTooltip from '../../components/RolesTooltip';
import FormField from '../../components/FormField';
import SmartFieldPhotoPicker from '../../components/SmartFieldPhotoPicker/SmartFieldPhotoPicker';
import SmartFieldPhotoCropper from '../../components/SmartFieldPhotoPicker/SmartFieldPhotoCropper';
import DefaultAvatar from '../../components/icons/defaultAvatar';
import MoreIcon from '../../components/icons/more';
import i18n from 'i18n/i18n';
import _ from 'lodash';
import Logger from '../../logger/logger';
import { clearConnectMlsState } from 'redux/modules/mls';
const log = Logger.get('Subscription');
import {
	withStyles,
	Typography,
	Menu,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	IconButton,
	Grid,
	Link,
	Tooltip,
	ClickAwayListener
} from '@material-ui/core';
import Fade from '@material-ui/core/Fade';
import { Button, Select } from '../../components/Features/components';
import { hideModal } from 'redux/modules/modal';
import { SortArrow, IconInvite, IconAddUsers, SpinnerIcon, IconMlsIdAdd, IconMlsIdDone, Info } from '../../theme/icons';
import SelectArrow from '@material-ui/icons/KeyboardArrowDown';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { DeleteIcon } from 'theme/icons';
import {
	addCompanyUsers,
	sendInviteToUsers,
	updateCompanyUser,
	deleteCompanyUser,
	estimateCostOnAddCompanyUsers,
	estimateCostOnUpdateCompanyUser,
	estimateCostOnDeleteCompanyUser,
	inviteUsersClearUsers,
	inviteUsersClearMessage,
	showRateLimitError,
	updateUserExternalId,
	clearExternalIdState,
	showErrorPopup,
	updateUserPhoto
} from 'redux/modules/companies';
import { writeUserSettings } from 'redux/modules/session';
import Header from '../../components/Header';
import Description from '../../components/Description';
import classNames from 'classnames';
import { showModal } from 'redux/modules/modal';
import {
	USER_ROLES,
	USER_ROLE_ADMIN,
	USER_ROLE_BASIC,
	USER_ROLE_GUEST,
	CURRENCIES,
	USER_TABLES,
	USER_TABLE_ADMINS_AND_MEMBERS,
	USER_TABLE_GUESTS,
	CAP_KEY,
	USER_PAGE_SETTINGS_KEY,
	TABLE_COLUMNS,
	SORT_ORDER,
	USER_TABLE_ALL,
	PACKAGES_CONFIG,
	SUBSCRIPTION_VIEW,
	SUBSCRIPTION_PLAN,
	ENABLE_MLS_ID_FIELD_FOR_INDUSTRIES,
	MLS_UI
} from '../../config';
import { parseQuery } from '../../utils/url';
import { focusSelect } from '../../utils/forms';
import {
	doesUserExist,
	sortUsers,
	getSavedTableSettings,
	getTableStyleProps,
	encodeUser,
	decodeUser,
	filterNonGuestUsers,
	PERMISSION_ROLE
} from '../../utils/users';
import {
	trackUserAdd,
	trackUserDelete,
	trackUserEdit
} from 'lib/Segment/customTrackers';
import { getTrackingOptions } from 'lib/Segment/helpers';
import CenteredContent from 'components/CenteredContent/CenteredContent';
import { 
	getCurrentPlanId,
	getCurrentPlanName,
	getMembersPaidQuantity,
	convertPlanIdIntoSubscription,
	getSubscriptionsAndAddons
} from '../../utils/subscription';
import { ROOT, SUBSCRIPTION, getRoute } from 'routes';
import AppError from '../../errors/apperror';

const localize = i18n.loc.localize;

const errors = {
	[ERROR.OFFLINE] : 'subscriptions-error-offline',
	[ERROR.EXTERNAL_IDS_INVALID_COMPANY_ID] : 'users-external-id-error-invalid-company-id',
	[ERROR.EXTERNAL_IDS_MUST_BE_AN_ARRAY] : 'users-external-id-error-external-ids-must-be-an-array',
	[ERROR.EXTERNAL_IDS_TARGET_USER_IS_NOT_IN_THE_COMPANY] : 'users-external-id-error-target-user-not-in-the-company',
	[ERROR.FAILED_TO_UPDATE_EXTERNAL_ID] : 'users-external-id-error-failed-to-update-external-id',
	[ERROR.DUPLICATE_MLS_IDS] : 'users-external-id-duplicates',
	[ERROR.UNKNOWN] : 'users-external-id-error-unknown',
};

const invalidMLSInputValue = {
	['invalid-value'] : 'users-table-mls-id-invalid-value',
	['already-used'] : 'users-table-mls-id-already-used',
};

const userTypeTable = [
	{
		name: localize('user-type-all'),
		select: (value) => value.role === USER_ROLE_ADMIN || value.role === USER_ROLE_BASIC
	},
	{
		name: localize('user-type-admins'),
		select: (value) => value.role === USER_ROLE_ADMIN
	},
	{
		name: localize('user-type-members'),
		select: (value) => value.role === USER_ROLE_BASIC
	},
	{
		name: localize('user-type-pending'),
		select: (value) => !value.userId
	}
];

const styles = theme => ({
	/* page header */
	stickyHeader: {
		paddingBottom: 30,
		marginBottom: 60,
		'&:after': {
			width: '100%',
			margin: '0 5%',
			[theme.breakpoints.up('md')]: {
				margin: 0
			}
		}
	},
	headerDescription: {
		margin: '0 0 40px'
	},
	
	...getTableStyleProps(USER_TABLE_ALL, theme),

	/* expansion panel */
	expansionPanel: {
		margin: 0,
		boxShadow: 'none',
		border: 0,
		'&::before': {
			display: 'none'
		}
	},
	expansionPanelSummary: {
		padding: 0,
		margin: 0,
		'&.expansionPanelSummaryExpanded': {
			minHeight: 48
		},
		'& > div:first-child': {
			margin: 0,
		},
		'&:hover h2': {
			color: '#2888C3'
		},
		'&:hover .expandUserTableIcon': {
			color: '#2888C3'
		}
	},
	expansionPanelDetails: {
		padding: 0
	},
	userType: {
		display: 'flex',
		justifyContent: 'space-between'
	},
	userTypeCount: {
		color: '#6F99BD'
	},
	panelExpanded: {
		'& .expandUserTableIcon': {
			transform: 'translateY(-50%) rotate(0deg)'
		}
	},

	columnTableToggleIcon: {
		position: 'relative',
		width: 33
	},
	expandUserTableIcon: {
		'position': 'absolute',
		'top': '50%',
		transform: 'translateY(-50%) rotate(-90deg)',
		'left': 0,
		transition: 'transform 0.2s'
	},
	/* More icon */
	iconMore: {
		color: '#282828'
	},
	/* delete icon */
	iconDelete: {
		color: '#282828'
	},
	/* inactive company message */
	errorInactiveCompany: {
		...theme.overrides.MuiFormHelperText.root['&$error'],
		opacity: 1,
		padding: '0 0 20px !important'
	},
	errorInactiveCompanyLink: {
		...theme.overrides.MuiFormHelperText.root['&$error'],
		padding: '0 !important',
		textDecoration: 'underline',
		opacity: 1,
		margin: '0 3px',
		'&:hover': {
			textDecoration: 'none'
		}
	},
	buttonInviteUsers: {
		marginLeft: '8px',
		background: theme.palette.colors.white,
		border: '1px solid black',
		paddingLeft: 20,
		paddingRight: 20,
		'&:hover': {
			borderWidth: '1px'
		}
	},

	/* avatar */
	avatarPlaceholder: {
		width: '40px',
		height: '40px',
		margin: '10px 25px',
		opacity: 0.32
	},
	defaultAvatar: {
		width: '40px',
		height: '40px'
	},
	photoPicker: {
		margin: '10px 25px'
	},
	select: {
		minWidth: '200px',
		marginBottom: '15px'
	},
	photoCell: {
		display: 'flex'
	},
	pendingSign: {
		display: 'inline-block',
		fontSize: '12px',
		fontWeight: '600',
		textAlign: 'center',
		borderRadius: '10px',
		backgroundColor: '#FFE6C1',
		color: '#AC5312',
		lineHeight: '20px',
		letterSpacing: '-0.24px',
		marginBottom: '10px',
		padding: '0px 7px'
	},

	/* error message */
	errorMessage:  {
		color: theme.palette.error.main,
		fontSize: 14,
		lineHeight: 1.5,
		opacity: 1
	},	
});

@withStyles(styles)
class Users extends Component {

	constructor(props) {
		super(props);
		const queryParams = parseQuery(props.location.search);
		const { email } = queryParams;

		this.handleUserEdit = this.handleUserEdit.bind(this);
		this.updateCompanyUser = this.updateCompanyUser.bind(this);
		this.handleUserDelete = this.handleUserDelete.bind(this);
		this.onRemoveMember = this.onRemoveMember.bind(this);
		this.changeUserRole = this.changeUserRole.bind(this);
		this.handleShowAddUserModal = this.handleShowAddUserModal.bind(this);
		this.handleSendInvitations = this.handleSendInvitations.bind(this);
		this.handleAddUsers = this.handleAddUsers.bind(this);
		this.clearExternalIdsForUser = this.clearExternalIdsForUser.bind(this);
		this.clearExternalIdsStateAfterRoleChange = this.clearExternalIdsStateAfterRoleChange.bind(this);
		this.hideAllMlsFields = this.hideAllMlsFields.bind(this);
		this.cleanMlsIdValue = this.cleanMlsIdValue.bind(this);
		this.handleOpenPhotoPicker = this.handleOpenPhotoPicker.bind(this);
		this.handleOpenPhotoCropper = this.handleOpenPhotoCropper.bind(this);
		this.onPhotoAdd = this.onPhotoAdd.bind(this);
		this.onManageMlsAgentsCloseHandler = this.onManageMlsAgentsCloseHandler.bind(this);

		const adminsAndMembersExpandedState = getSavedTableSettings(
			this.props.settings,
			USER_TABLE_ADMINS_AND_MEMBERS,
			'expanded');

		const guestsExpandedState = getSavedTableSettings(
			this.props.settings,
			USER_TABLE_GUESTS,
			'expanded');

		this.inputRefs = {};
		this.photoPickerRefs = {};

		this.onCropPhotoRef = React.createRef();
		this.onCropPhotoRef.current = (companyId, userId, result) => {
			const { blob } = result;

			// Convert Blob back to File object.
			const croppedFile = new File([blob], `photo.${result.extension}`, { type: blob.type });

			this.setState({ loadingPhotoUserId: userId });
			this.props.updateUserPhoto(croppedFile, companyId, userId).then((data) => {
				this.setState({ loadingPhotoUserId: null });
				if (data instanceof AppError) {
					return;
				}
			});
		};

		this.state = {
			...this.getStateFromProps(props),
			willChangeRole: false,
			shownMlsFields: {},
			showPhotoCropper: false,
			loadingPhotoUserId: null,
			photoCropperUrl: '',
			photoCropperKey: null,
			focusedField: {},
			mlsFieldsWithErrors: {},
			updatingMlsIdForUsers: {},
			newExternalIds: {},
			userTypeIdx: 0,
			moreAnchorEl: null,
			moreMenuUser: null,
			table: {
				[USER_TABLE_ADMINS_AND_MEMBERS]: {
					expanded: adminsAndMembersExpandedState !== undefined ? adminsAndMembersExpandedState : true,
					sortKey: getSavedTableSettings(this.props.settings, USER_TABLE_ADMINS_AND_MEMBERS, 'sortKey'),
					sortOrder: getSavedTableSettings(this.props.settings, USER_TABLE_ADMINS_AND_MEMBERS, 'sortOrder')
				},
				[USER_TABLE_GUESTS]: {
					expanded: guestsExpandedState !== undefined ? guestsExpandedState : true,
					sortKey: getSavedTableSettings(this.props.settings, USER_TABLE_GUESTS, 'sortKey'),
					sortOrder: getSavedTableSettings(this.props.settings, USER_TABLE_GUESTS, 'sortOrder')
				}
			}
		};

		if (email || ('add-user' in queryParams) || ('show-add-users-modal' in queryParams)) { // 'add-user' param can be empty
			const userEmail = email || queryParams['add-user'] || '';
			if (doesUserExist(this.state.users, userEmail, USER_ROLE_GUEST)) {
				// [P9052-10005] Show a confirmation popup to upgrade Guest to Member
				this.confirmRoleUpgrade(USER_ROLES[USER_ROLE_BASIC].label, userEmail, this.getUserIdForEmail(email));
			} else {
				// [P9052-10177] Predefine user in the input
				this.handleShowAddUserModal(userEmail);
			}
		}
	}

	componentWillReceiveProps(props) {
		this.setState({
			...this.getStateFromProps(props),
		});
	}

	getStateFromProps(props) {
		const { currentPlanName } = props;
		const { rawDataById, selectedId } = props.companies;
		const company = rawDataById[selectedId];
		const { users, hasActiveSubscription } = company;
		return { users, hasActiveSubscription, currentPlanName, selectedId, company };
	}
	
	componentDidMount() {
		if (this.props.askToCompleteCompanyProfile) {
			this.showCompleteTeamProfileModal();
		}

		if (this.props.mls.mlsUiType === MLS_UI.DIRECT_MLS_API) {
			const newExternalIds = {}; 
			this.state.users.forEach((user, index) => {
				const { userId, externalIds } = user;
				if (userId) {
					newExternalIds[userId] = !_.isEmpty(externalIds) ? _.clone(externalIds) : [''];
				}
			});

			this.props.clearExternalIdState();
			this.setState({ newExternalIds });
		}
	}

	componentDidUpdate(prevProps, prevState) {

		if (this.props.mls.mlsUiType === MLS_UI.DIRECT_MLS_API) {
			const { rawDataById: rawDataByIdPrev, selectedId: selectedIdPrev } = prevProps.companies;
			const companyPrev = rawDataByIdPrev[selectedIdPrev];
			const { users: usersPrev } = companyPrev;
			const usersUpdated = this.getCompanyUsers();

			usersUpdated.forEach((updatedUser, index) => {
				
				const oldUser = usersPrev.find(u => u.email === updatedUser.email);
				if (oldUser) {
					if (!_.isEqual(oldUser.externalIds, updatedUser.externalIds)) {
						
						if (!_.isEqual(
								this.props.companies.updatingExternalIdSuccess,
								prevProps.companies.updatingExternalIdSuccess) &&
							this.props.companies.updatingExternalIdSuccess.includes(updatedUser.userId)
						) {
							
							const updatingMlsIdForUsers = _.clone(this.state.updatingMlsIdForUsers);
							delete updatingMlsIdForUsers[updatedUser.userId];

							const shownMlsFields = _.clone(this.state.shownMlsFields);
							delete shownMlsFields[updatedUser.userId];
						
							const focusedField = _.clone(this.state.focusedField);
							delete focusedField[updatedUser.userId];

							// update existing external id record
							if (!_.isEqual(updatingMlsIdForUsers, this.state.updatingMlsIdForUsers)) {
								this.setState({ updatingMlsIdForUsers, shownMlsFields, focusedField });
							}

							// delete single MLS id
							if (_.isArray(updatedUser.externalIds) &&
								_.isArray(oldUser.externalIds) &&
								updatedUser.externalIds.length < oldUser.externalIds.length) {

								const newExternalIds = _.clone(this.state.newExternalIds);
								const nonEmptyValues = this.state.newExternalIds[updatedUser.userId]
									.filter(id => this.cleanMlsIdValue(id).length);
								newExternalIds[updatedUser.userId] = nonEmptyValues.length ? nonEmptyValues : [''];
								
								const mlsFieldsWithErrors = _.clone(this.state.mlsFieldsWithErrors);
								delete mlsFieldsWithErrors[updatedUser.userId];

								this.setState({ newExternalIds, mlsFieldsWithErrors });
							}
						}
					} else {
						// By default init externalIds to '', for example if user is changed from guest to member/admin
						const newExternalIds = _.clone(this.state.newExternalIds);
						if (updatedUser.userId && !_.get(this.state.newExternalIds, `[${updatedUser.userId}]`)) {
							newExternalIds[updatedUser.userId] = [''];
							this.setState({ newExternalIds });
						}
					}
				}
			});

			if (!_.isEmpty(this.props.companies.updatingExternalIdErrorId)) {
				
				const updatingMlsIdForUsers = _.clone(this.state.updatingMlsIdForUsers);

				Object.keys(updatingMlsIdForUsers).map(currentUserId => {

					const apiError = this.props.companies.updatingExternalIdErrorId.find(user => user.userId === currentUserId);

					if (apiError) {
						Object.keys(updatingMlsIdForUsers[currentUserId]).map(currentUserIndex => {

							if (_.get(this.state.updatingMlsIdForUsers, `[${currentUserId}][${currentUserIndex}]`)) {
								const shownMlsFields = _.clone(this.state.shownMlsFields);
								shownMlsFields[currentUserId] = shownMlsFields[currentUserId] || {};
								shownMlsFields[currentUserId][currentUserIndex] = true;
								
								delete updatingMlsIdForUsers[currentUserId][currentUserIndex];
								this.setState({ updatingMlsIdForUsers, shownMlsFields });
							}
												
						});
					}
				});
			}			
		}
	}
	
	/**
	 * Show a confirmation popup on the user upgrade
	 * @param {string} newRole The new role
	 * @param {string} email User's email
	 *
	 * @memberof Users
	 */
	confirmRoleUpgrade(newRole, email, userId) {
		this.props.showModal('CONFIRMATION_MODAL', {
			message: localize('users-confirm-role-upgrade', email),
			buttons: [
				<Button
					key='button-cancel'
					variant='outlined'
					color='primary'
				>
					{localize('no')}
				</Button>,
				<Button
					key='button-confirm'
					variant='contained'
					color='primary'
					onClick={() => this.handleUserEdit(newRole, email, userId)}
				>
					{localize('yes')}
				</Button>
			]
		});
	}

	handleTableToggle(e, tableId) {
		if (e.target.closest('.columnTableInfo')) return; // Ignore click on info icon
		const tablesState = this.state.table;
		const isTableExpanded = !tablesState[tableId].expanded;
		tablesState[tableId].expanded = isTableExpanded;
		this.setState(tablesState);

		// use same settings in all companies
		const userPageSettings = _.get(this.props.settings,
			`${CAP_KEY}.${USER_PAGE_SETTINGS_KEY}`, {});

		userPageSettings[tableId] || (userPageSettings[tableId] = {});
		userPageSettings[tableId].expanded = isTableExpanded;

		this.props.writeUserSettings({
			[USER_PAGE_SETTINGS_KEY]: userPageSettings
		});		
	}

	sortTable(tableId, newSortColumnKey) {
		const tablesState = this.state.table;

		const currentSortKey = tablesState[tableId].sortKey;
		const currentSortOrder = tablesState[tableId].sortOrder;

		if (!currentSortKey) {
			tablesState[tableId].sortKey = newSortColumnKey;
			tablesState[tableId].sortOrder = SORT_ORDER.DESC;
		} else if (currentSortKey === newSortColumnKey) {
			tablesState[tableId].sortOrder = currentSortOrder === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC;
		} else if (currentSortKey !== newSortColumnKey) {
			tablesState[tableId].sortKey = newSortColumnKey;
			tablesState[tableId].sortOrder = SORT_ORDER.ASC;

		}
		this.setState(tablesState);

		// use same settings in all companies
		const userPageSettings = _.get(this.props.settings,
			`${CAP_KEY}.${USER_PAGE_SETTINGS_KEY}`, {});

		userPageSettings[tableId] || (userPageSettings[tableId] = {});
		userPageSettings[tableId].sortKey = tablesState[tableId].sortKey;
		userPageSettings[tableId].sortOrder = tablesState[tableId].sortOrder;

		this.props.writeUserSettings({
			[USER_PAGE_SETTINGS_KEY]: userPageSettings
		});			
	}

	onPhotoAdd(e, updatedUser) {
		const file = e.currentTarget.files[0];
		e.currentTarget.value = '';

		this.setState({ loadingPhotoUserId: updatedUser.userId });
		this.props.updateUserPhoto(file, this.state.company.id, updatedUser.userId).then((data) => {
			this.setState({ loadingPhotoUserId: null });
			if (data instanceof AppError) {
				return;
			}
		}).catch((error) => {
			this.setState({ loadingPhotoUserId: null });
		});
	}

	handleOpenPhotoPicker(refId) {
		if (this.photoPickerRefs[refId].current) {
			this.photoPickerRefs[refId].current.click();
		}
	}

	async handleOpenPhotoCropper(key, value) {
		this.setState({ showPhotoCropper: true, photoCropperUrl: value, photoCropperKey: key });
	}

	handleRemovePhoto(userId) {
		this.props.updateUserPhoto(null, this.state.company.id, userId).then((data) => {
			if (data instanceof AppError) {
				return;
			}
		});
	}

	renderErrorLoadingMlsData() {
		const { classes } = this.props;
		const errorMessage = localize('mls-error-loading-mls-data');

		return (
			<Typography
				className={classNames(
					{
						[classes.errorMessage]: true,
						['errorMessage']: true
					}
				)}						
				variant="body2">{errorMessage}</Typography>
		);			
	}

	render() {
		const { redirectUrl, preselectSubscriptionView, preselectOpenCBDetails } = this.state;
		const { classes } = this.props;
		const { getConnectionsErrorId, getAgentsMlsIdsErrorId, mlsBoardListFailedToLoad } = this.props.mls;

		if (redirectUrl) {
			return (<Redirect 
				to={{
					pathname: redirectUrl,
					...((preselectSubscriptionView || preselectOpenCBDetails) &&
						{state: { preselectSubscriptionView, preselectOpenCBDetails }})
				}}
			/>);
		}

		return (
			<CenteredContent>
				<StickyHeader className={classes.stickyHeader}>
					<Header>{localize('users-header')}</Header>
					<Description className={classes.headerDescription}>{localize('users-description')}</Description>
					<Button
						variant='contained'
						data-tid="button-user-add"
						color='primary'
						onClick={() => this.handleShowAddUserModal()}
						className={classes.buttonAddUsers}>
						<IconAddUsers className={classes.iconAddUsers} />
						{localize('users-add')}
					</Button>
					<Button
						variant='outlined'
						data-tid="button-user-send-invitations"
						color='primary'
						onClick={() => this.handleSendInvitations()}
						className={classes.buttonInviteUsers}>
						<IconInvite className={classes.iconAddUsers} />
						{localize('users-send-invitations')}
					</Button>
				</StickyHeader>
				{!this.props.askToCompleteCompanyProfile && (this.renderInactiveCompanyInformation(classes))}

				{this.props.mls.mlsUiType === MLS_UI.SELF_CONNECT_API &&
				(getConnectionsErrorId || getAgentsMlsIdsErrorId || mlsBoardListFailedToLoad) && 
				this.renderErrorLoadingMlsData()
				}

				{!this.props.askToCompleteCompanyProfile &&
					this.renderUserTable(
						USER_TABLE_ADMINS_AND_MEMBERS,
						[USER_ROLE_ADMIN, USER_ROLE_BASIC],
						this.state.newExternalIds)}
				
				{!this.props.askToCompleteCompanyProfile &&
					this.renderUserTable(USER_TABLE_GUESTS, [USER_ROLE_GUEST])}
			</CenteredContent>
		);
	}

	handleMenuOpen = (event, user) => {
		this.setState({
			moreAnchorEl: event.currentTarget,/*.parentElement*/
			moreMenuUser: user
		});
	};

	handleMenuClose = () => {
		this.setState({ moreAnchorEl: null });
	};

	renderUserTable(tableId, renderRoles, externalIds) {
		const { classes } = this.props;
		const { users } = this.state;
		const { expanded, sortKey, sortOrder } = this.state.table[tableId];
		const showTypeSelect = tableId === USER_TABLE_ADMINS_AND_MEMBERS;
		const sourceUsers = users.filter(user => renderRoles.includes(user.role));
		// If it's admins and members table, also filter by user type set by this.state.userTypeIdx
		const usersToRender = sortUsers(sourceUsers.filter(user => showTypeSelect ? userTypeTable[this.state.userTypeIdx].
			select(user, this.state.company.email) : true), sortKey, sortOrder);
		const showMlsIdColumn = tableId === USER_TABLE_ADMINS_AND_MEMBERS &&
			ENABLE_MLS_ID_FIELD_FOR_INDUSTRIES.includes(this.props.company.industryId);
		const showUserPhoto = tableId === USER_TABLE_ADMINS_AND_MEMBERS;
		const tableLabel = !showTypeSelect || !this.state.userTypeIdx ? USER_TABLES[tableId].label :
			userTypeTable[this.state.userTypeIdx].name;

		return (
			<ExpansionPanel
				expanded={expanded}
				className={classNames({
					[classes.expansionPanel]: true,
					[classes.panelExpanded]: expanded
				})}
				onMouseLeave={() => showMlsIdColumn && this.hideAllMlsFields(false)}
				onChange={(e) => this.handleTableToggle(e, tableId)}>
				<ExpansionPanelSummary className={classNames({
					[classes.expansionPanelSummary]: true,
					['expansionPanelSummaryExpanded']: expanded
				})}>
					<Grid container direction="row" className={classNames({[classes.tableHead]: !showTypeSelect})}>
						<Grid item className={classes.columnTableToggleIcon}>
							<ExpandMore
								style={{ fontSize: 27 }}
								className={classNames({
									[classes.expandUserTableIcon]: true,
									['expandUserTableIcon']: true
								})}			
							/>
						</Grid>
						<Grid item className={classes.columnTableTitle}>
							<Typography className={classes.tableTitle} variant="h2">
								{tableLabel} ({usersToRender.length})
							</Typography>
						</Grid>
						<Grid
							item
							container
							justify="center"
							className={classNames({
								[classes.columnTableInfo]: true,
								['columnTableInfo']: true
							})}
						>
							<RolesTooltip tableId={tableId} />
						</Grid>
					</Grid>
				</ExpansionPanelSummary>
				{showTypeSelect && (
					<Select
						className={classes.select}
						id="select-user-type"
						value={this.state.userTypeIdx}
						disableUnderline
						onChange={(event) => this.setState({userTypeIdx: event.target.value})}
						renderValue={value => (<div>{localize('user-type-type') + userTypeTable[value].name}</div>)}
					>
						{userTypeTable.map((type, index) => (
							<MenuItem className={classes.userType} key={type.name} value={index}>
								<div>{type.name}</div>
								<div className={classes.userTypeCount}>
									{'(' + sourceUsers.filter(user => userTypeTable[index].
										select(user, this.state.company.email)).length + ')'}
								</div>
							</MenuItem>
						))}
					</Select>
				)}
				<ExpansionPanelDetails className={classes.expansionPanelDetails}>
					{usersToRender.length === 0
						?
						(<Typography variant='body2' className={classes.noUsersFound}>
							{localize('users-table-no-guests-found')}
						</Typography>)
						:
						(
							<ClickAwayListener onClickAway={() => { showMlsIdColumn && this.hideAllMlsFields(true); }}>
								<Table className={classes.table} key={`user-table-${tableId}`}>
									<TableHead>
										<TableRow className={classes.tableHeadRow}>
											<TableCell
												padding='dense'
												className={classNames(
													{
														[classes.noBorderedCell]: true,
														[classes.tableNameCellHeader]: true,
														[classes.tableCellHeader]: true,
														[classes.tableHasSortArrow]: true,
														['rowHasMls']: showMlsIdColumn
													}
												)}>
												<IconButton
													className={classNames({
														[classes.sortArrow]: true,
														['sortArrow']: true,
														['desc']: sortKey === TABLE_COLUMNS.FULL_NAME &&
															sortOrder === SORT_ORDER.DESC,
														['active']: sortKey === TABLE_COLUMNS.FULL_NAME
													})}
													component='span'
													aria-label={localize('users-table-change-sorting-order')}
													onClick={() => this.sortTable(tableId, TABLE_COLUMNS.FULL_NAME)}
												>
													<SortArrow className={classes.sortArrowIcon} />
												</IconButton>
												{localize('users-table-header-name')}
											</TableCell>
											{showUserPhoto && (
												<TableCell
													padding='none'
													className={classNames(
														classes.noBorderedCell,
														classes.tableCellHeader,
														classes.tablePhotoCellHeader,
														classes.tableHasSortArrow
													)}
												>
													{localize('users-table-header-photo')}
												</TableCell>
											)}

											<TableCell
												padding='dense'
												className={classNames(
													{
														[classes.noBorderedCell]: true,
														[classes.tableEmailCellHeader]: true,
														[classes.tableCellHeader]: true,
														[classes.tableHasSortArrow]: true,
														['rowHasMls']: showMlsIdColumn
													}
												)}>
												<IconButton
													className={classNames({
														[classes.sortArrow]: true,
														['sortArrow']: true,
														['desc']: sortKey === TABLE_COLUMNS.EMAIL &&
															sortOrder === SORT_ORDER.DESC,
														['active']: sortKey === TABLE_COLUMNS.EMAIL
													})}
													component='span'
													aria-label={localize('users-table-change-sorting-order')}
													onClick={() => this.sortTable(tableId, TABLE_COLUMNS.EMAIL)}
												>
													<SortArrow className={classes.sortArrowIcon} />
												</IconButton>											
												{localize('users-table-header-email')}
											</TableCell>

											{showMlsIdColumn && (
												<TableCell
													padding='none'
													className={classNames(
														classes.tableMLSCellHeader,
														classes.noBorderedCell,
														classes.tableCellHeader,
														classes.tableHasSortArrow
													)}
												>
													<IconButton
														className={classNames({
															[classes.sortArrow]: true,
															['sortArrow']: true,
															['desc']: sortKey === TABLE_COLUMNS.MLS_ID &&
																sortOrder === SORT_ORDER.DESC,
															['active']: sortKey === TABLE_COLUMNS.MLS_ID
														})}
														component='span'
														aria-label={localize('users-table-change-sorting-order')}
														onClick={() => this.sortTable(tableId, TABLE_COLUMNS.MLS_ID)}
													>
														<SortArrow className={classes.sortArrowIcon} />
													</IconButton>											

													<p className={classes.tableMLSCellHeaderLabel}>
														{localize('users-table-header-mls')}
													</p>

													<Tooltip
														placement="top"
														title={
															<Fragment>
																<Typography
																	variant='body2'
																	className={classNames(classes.infoTooltipText)}>
																	{localize('users-table-header-mls-tooltip')}
																</Typography>
																<span className={classes.tooltipArrow} />
															</Fragment>
														}
														classes={{
															tooltip: classes.mlsInfoTooltipTableHead
														}}
													>
														<IconButton
															className={classes.infoIconButton}
															color='primary'
															component='span'
															disableRipple
														>
															<Info />
														</IconButton>														
													</Tooltip>
																									
												</TableCell>
											)}

											<TableCell
												padding='none'
												className={classNames(
													classes.tableRoleCellHeader,
													classes.noBorderedCell,
													classes.tableCellHeader,
													classes.tableHasSortArrow
												)}
											>
												{tableId === USER_TABLE_ADMINS_AND_MEMBERS && (
													<IconButton
														className={classNames({
															[classes.sortArrow]: true,
															['leftAligned']: true,
															['sortArrow']: true,
															['desc']: sortKey === TABLE_COLUMNS.ROLE &&
																sortOrder === SORT_ORDER.DESC,
															['active']: sortKey === TABLE_COLUMNS.ROLE
														})}
														component='span'
														aria-label={localize('users-table-change-sorting-order')}
														onClick={() => this.sortTable(tableId, TABLE_COLUMNS.ROLE)}
													>
														<SortArrow className={classes.sortArrowIcon} />
													</IconButton>											
												)}
												{localize('users-table-header-user-role')}
											</TableCell>
											<TableCell
												align='right'
												padding='none'
												className={classNames(
													classes.tableActionsCell,
													classes.noBorderedCell
												)}
											/>
										</TableRow>
									</TableHead>
									<TableBody>
										{this.renderUserRows(renderRoles, usersToRender, showMlsIdColumn, showUserPhoto,
											externalIds)}
									</TableBody>				
								</Table>
								{this.state.showPhotoCropper && (
									<SmartFieldPhotoCropper
										photoUrl={this.state.photoCropperUrl}
										scale={1}
										onCropCb={
											(result) => this.onCropPhotoRef.current &&
											this.onCropPhotoRef.current(this.state.company.id, this.state.photoCropperKey, result)
										}
										hideModal={() => this.setState({showPhotoCropper: false})}
									/>
								)}
								<Menu
									anchorEl={this.state.moreAnchorEl}
									open={Boolean(this.state.moreAnchorEl)}
									onClose={this.handleMenuClose}
									anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
									transformOrigin={{ vertical: 'top', horizontal: 'left' }}
								>
									<MenuItem
										onClick={() => {
											this.handleMenuClose();
											this.onRemoveMember(this.handleUserDelete, {
												email: this.state.moreMenuUser.email,
												user: encodeUser(this.state.moreMenuUser)
											});
										}}
									>
										{localize('subscription-reduce-action-remove')}
									</MenuItem>
									<MenuItem onClick={() => {
										this.handleMenuClose();
										this.handleAddUsers([{
											email: this.state.moreMenuUser.email,
											id: new Date().getTime(),
											role: this.state.moreMenuUser.role
										}], null);}}
									>
										{localize('user-menu-send-invite')}
									</MenuItem>
								</Menu>

							</ClickAwayListener>				
						)
					}
				</ExpansionPanelDetails>
			</ExpansionPanel>
		);
	}

	renderMLSFormField(userId, externalId, index) {
		const { classes } = this.props;
		const errorClasses = { error: classes.mlsErrorMessage };
		this.inputRefs[`input-mls-${userId}-${index}`] = React.createRef();
		const errorMessageKey = _.get(this.state.mlsFieldsWithErrors, `[${userId}][${index}]`);

		return (
			<Tooltip
				placement="top"
				open={!_.get(this.state.focusedField, `[${userId}][${index}]`)}
				title={
					<Fragment>
						<Typography
							variant='body2'
							className={classNames({
								[classes.infoTooltipText]: true,
								[classes.mlsPendingPrompt]: !userId
							})}
						>
							{localize(userId ? 'users-table-enter-agent-mls-id' : 'user-table-mls-pending-prompt')}
						</Typography>
						<span className={classes.tooltipArrow} />
					</Fragment>
				}
				classes={{
					tooltip: classes.mlsInfoTooltipTableBody
				}}
			>
				<FormField
					value={externalId || ''}
					autoComplete='off'
					className={classNames(classes.mlsInputField)}
					data-tid={'mls-id-field'}
					onChange={event => this.onMLSFieldChange(event, userId, index)}
					onKeyPress={event => this.onMLSFieldKeyPress(event, userId, index)}
					onKeyDown={event => this.onMLSFieldBlur(event)}
					onFocus={event => this.onMLSFieldFocus(userId, index)}
					margin="normal"
					id={`input-mls-${userId}-${index}`}
					helperText={errorMessageKey && localize(errorMessageKey)}
					error={!!_.get(this.state.mlsFieldsWithErrors, `[${userId}][${index}]`)}
					FormHelperTextProps={{ classes: errorClasses }}
					inputRef={this.inputRefs[`input-mls-${userId}-${index}`]}
				/>
			</Tooltip>
		);
	}

	renderMLSCell(userId, externalIds) {
		const { classes } = this.props;
		const { 
			getConnectionsErrorId,
			getAgentsMlsIdsErrorId, 
			mlsBoardListFailedToLoad,
			getAgentsMlsIdsSuccess,
			getConnectionsSuccess,
			mlsBoardList,
			connections
		} = this.props.mls;

		if (!userId) {
			return (
				<TableCell
					padding='dense'
					className={classNames(classes.tableCellBody, classes.mlsPendingPrompt)}
				>
					{localize('user-table-mls-pending-prompt')}
				</TableCell>
			);
		}

		if (this.props.mls.mlsUiType === MLS_UI.SELF_CONNECT_API) {

			let selfStartMlsIdsForUser = [];
			if (Array.isArray(this.props.mls.agentsMlsIds)) {
				selfStartMlsIdsForUser = this.props.mls.agentsMlsIds
					.filter(item => item.userId === userId)
					.map(item => item.agentMlsId);
			}

			return (
				<TableCell padding='dense' className={classes.tableCellBody}>
					{
						getConnectionsErrorId || getAgentsMlsIdsErrorId || mlsBoardListFailedToLoad
							?
							this.renderMLSFieldContentError(userId)
							:
							!getConnectionsSuccess || !getAgentsMlsIdsSuccess || mlsBoardList.length === 0
								?
								this.renderMLSFieldContentLoading(userId)
								:
								connections.length
									?
									selfStartMlsIdsForUser.length
										?
										this.renderMLSFieldContentClickToEdit(userId, selfStartMlsIdsForUser)
										:
										this.renderMLSFieldContentClickToEnter(userId)
									:
									this.renderMLSFieldContentNoConnections(userId)

					}
				</TableCell>);

		} else if (this.props.mls.mlsUiType === MLS_UI.DIRECT_MLS_API) {
			const apiError = this.props.companies.updatingExternalIdErrorId.find(user => user.userId === userId);
			const errorMessageKey = apiError && apiError.errorId && errors[apiError.errorId] || errors[ERROR.UNKNOWN];

			return (
				<TableCell padding='dense' className={classes.tableCellBody}>
					{
						externalIds && externalIds.map((externalId, index) => {
							return _.get(this.state.updatingMlsIdForUsers, `[${userId}][${index}]`)
								?
								this.renderMLSFieldContentUpdatingState(userId, externalId, index)
								:
								_.get(this.state.shownMlsFields, `[${userId}][${index}]`)
									?
									!this.props.companies.updatingExternalIdXhrInProgress.includes(userId) 
										?
										this.renderMLSFieldContentInputField(userId, externalId, index)
										:
										this.renderMLSFieldContentNonEditableValue(userId, externalId, index)
									:
									externalId === ''
										?
										this.renderMLSFieldContentNoExternalId(userId, index)
										:
										this.renderMLSFieldContentNonEditableValue(userId, externalId, index);
						})
					}
					{apiError && (
						<Typography variant='body2' className={classNames(classes.externalIdsErrorMessage)}>
							{localize(errorMessageKey)}
						</Typography>
					)}
				</TableCell>
			);			
		}
	}

	renderMLSFieldContentInputField(userId, externalId, index) {
		const { classes } = this.props;
		const apiError = this.props.companies.updatingExternalIdErrorId.find(user => user.userId === userId);

		const saveEnabled = this.isMLSSaveEnabled(userId, index);
		const addFieldEnabled = this.isMLSAddFieldEnabled(userId, index) && !apiError;
		const shouldRenderActionIcons = _.get(this.state.focusedField, `[${userId}][${index}]`);

		return (
			<div
				key={`user-input-field-${userId}-${index}`}
				onMouseEnter={() => this.showMLSField(userId, index)}
				className={classes.singleMlsIdField}>
				<Grid container direction="row" className={classes.mlsIdFieldGrid}>
					<Grid item className={classes.mlsIdFieldWrapper}>
						{this.renderMLSFormField(userId, externalId, index)}
					</Grid>
					<Grid item className={classes.mlsFieldActionIcon}>
						{
							(shouldRenderActionIcons || apiError) && (//show Save icon to enable resubmit
								<Tooltip
									placement="top"
									disableHoverListener={!saveEnabled || apiError}
									disableFocusListener={!saveEnabled || apiError}
									title={
										<Fragment>
											<Typography variant='body2' className={classNames(classes.infoTooltipText)}>
												{localize('users-table-mls-id-done')}
											</Typography>
											<span className={classes.tooltipArrow} />
										</Fragment>
									}
									classes={{
										tooltip: classes.infoTooltip
									}}
								>
									<IconMlsIdDone
										className={classNames({
											[classes.mlsActionIcon]: true,
											[classes.mlsIconDone]: true,
											[classes.mlsIconEnabled]: saveEnabled,
											['mls-icon-hover']: saveEnabled,
											['mls-icon-done']: true
										})}
										onClick={(event) => saveEnabled && this.saveMLSFieldChanges(userId, index)} 
									/>									
								</Tooltip>
							)
						}
					</Grid>
					<Grid item className={classes.mlsFieldActionIcon}>
						{
							shouldRenderActionIcons && (
								<Tooltip
									placement="top"
									disableHoverListener={!addFieldEnabled}
									disableFocusListener={!addFieldEnabled}
									title={
										<Fragment>
											<Typography variant='body2' className={classNames(classes.infoTooltipText)}>
												{localize('users-table-mls-id-add')}
											</Typography>
											<span className={classes.tooltipArrow} />
										</Fragment>
									}
									classes={{
										tooltip: classes.infoTooltip
									}}
								>			
									<IconMlsIdAdd
										className={classNames({
											[classes.mlsActionIcon]: true,
											[classes.mlsIconAdd]: true,
											[classes.mlsIconEnabled]: addFieldEnabled,
											['mls-icon-hover']: addFieldEnabled,
											['mls-icon-add']: true
										})}
										onClick={() => addFieldEnabled && this.addNewMlsFieldRow(userId, index)} 
									/>
								</Tooltip>
							)
						}
					</Grid>
				</Grid>
			</div>		
		);
	}

	/* selfStart1 - loading data  */
	renderMLSFieldContentLoading(userId) {
		const { classes } = this.props;
		return (
			<div
				key={`user-selfstart-loading-${userId}`}
				className={classes.loadingSelfStartMlsId}
			>
				<SpinnerIcon className={classes.updatingUserIcon} />
			</div>
		);
	}	

	/* selfStart1 - mls error loading data  */
	renderMLSFieldContentError(userId) {
		const { classes } = this.props;
		const errorMessage = localize('mls-field-error-data-not-loaded');

		return (
			<Typography
				key={`user-selfstart-error-${userId}`}
				className={classes.errorSelfStartMlsId}						
				variant="body2">{errorMessage}</Typography>
		);			
	}

	/* selfStart1 - list of MLS IDs  */
	renderMLSFieldContentClickToEdit(userId, selfStartMlsIdsForUser) {
		const { classes } = this.props;
		return (
			<div
				key={`user-selfstart-value-${userId}`}
				onClick={() => this.handleManageMlsAgents(userId, selfStartMlsIdsForUser)}
				className={classes.nonEmptySelfStartMlsId}
			>
				<Typography variant="body2" dangerouslySetInnerHTML={{ __html: selfStartMlsIdsForUser.join('<br />') }} />
			</div>
		);		
	}		

	/* selfStart1 empty field - empty MLS ID field */
	renderMLSFieldContentClickToEnter(userId) {
		const { classes } = this.props;
		return (
			<div
				key={`user-no-selfstart-value-${userId}`}
				onClick={() => this.handleManageMlsAgents(userId)}
				className={classes.emptySelfStartMlsId}
			>
				{localize(userId ? 'users-table-click-to-enter-agent-mls-id' : 'user-table-mls-pending-prompt')}
			</div>
		);
	}		

	/* selfStart1 no connections setup  */
	renderMLSFieldContentNoConnections(userId) {
		const { classes } = this.props;
		return (
			<div
				key={`user-no-ml-connections-${userId}`}
				className={classes.noConnectionSelfStartMlsId}
			>
				{localize('users-table-mls-no-connections')}
			</div>
		);	
	}

	/* custom integration - empty MLS ID field */
	renderMLSFieldContentNoExternalId(userId, index) {
		const { classes } = this.props;
		return (
			<div
				key={`user-no-external-id-${userId}-${index}`}
				onMouseEnter={() => this.showMLSField(userId, index)}
				className={classes.emptyExternalMlsId}
			>
				{localize(userId ? 'users-table-enter-agent-mls-id' : 'user-table-mls-pending-prompt')}
			</div>
		);		
	}	

	renderMLSFieldContentNonEditableValue(userId, externalId, index) {
		const { classes } = this.props;
		return (
			<div
				key={`user-non-editable-value-${userId}-${index}`}
				onMouseEnter={() => this.showMLSField(userId, index)}
				className={classes.nonEditableMlsIdValueNode}
			>
				{externalId}
			</div>
		);		
	}

	renderMLSFieldContentUpdatingState(userId, externalId, index) {
		const { classes } = this.props;
		return (
			<div
				key={`user-updating-state-${userId}-${index}`}
				className={classes.updatingMlsIdNode}
			>
				<Grid container direction="row" className={classes.updatingMlsUserGrid}>
					<Grid item className={classes.updatingMlsUserValue}>
						{externalId}
					</Grid>
					<Grid item className={classes.updatingMlsUserIcon}>
						<SpinnerIcon className={classes.updatingUserIcon} />
					</Grid>
				</Grid>
			</div>
		);
	}

	hasFocusedField() {
		let result;
		const focusedField = this.state.focusedField;
		Object.keys(focusedField).map(currentUserId => {
			Object.keys(focusedField[currentUserId]).map(currentUserIndex => {
				if (_.get(this.state.focusedField, `[${currentUserId}][${currentUserIndex}]`)) {
					result = true;
				}
			});
		});
		return result;
	}

	showMLSField(userId, index) {
		const shownMlsFields = _.clone(this.state.shownMlsFields);

		Object.keys(shownMlsFields).map(currentUserId => {
			Object.keys(shownMlsFields[currentUserId]).map(currentUserIndex => {
				if (!_.get(this.state.focusedField, `[${currentUserId}][${currentUserIndex}]`)) {
					delete shownMlsFields[currentUserId][currentUserIndex];
				}
			});
		});

		if (!shownMlsFields[userId]) {
			shownMlsFields[userId] = {};
		}
		shownMlsFields[userId][index] = true;

		this.setState({ shownMlsFields });
	}

	saveMLSFieldChanges(userId, index) {
		const value = this.state.newExternalIds[userId][index];
		const newExternalIds = _.clone(this.state.newExternalIds);
		newExternalIds[userId][index] = value;

		this.setState({ newExternalIds }, () => {
			this.updateExternalIdsForUser(userId, index);
		});
	}

	addNewMlsFieldRow(userId, index) {
		this.resetLastFocusedMLSField(false, true);

		const newExternalIds = _.clone(this.state.newExternalIds);

		const nextRowIndex = newExternalIds[userId].length;
		this.inputRefs[`input-mls-${userId}-${nextRowIndex}`] = React.createRef();

		newExternalIds[userId].push('');

		const shownMlsFields = _.clone(this.state.shownMlsFields);
		if (!shownMlsFields[userId]) {
			shownMlsFields[userId] = {};
		}
		shownMlsFields[userId][nextRowIndex] = true;

		// update focused field
		const focusedField = {};
		focusedField[userId] = {};
		focusedField[userId][index] = true;

		this.setState({ newExternalIds, shownMlsFields, focusedField }, () => {
			focusSelect(this.inputRefs[`input-mls-${userId}-${nextRowIndex}`].current);
		});
	}

	onMLSFieldChange(event, userId, index) {
		this.validateMlsId(event.target.value, userId, index);

		const newExternalIds = _.clone(this.state.newExternalIds);
		newExternalIds[userId][index] = event.target.value;
		this.setState({ newExternalIds });

		// Clear API error mesassage when he edits field after ERROR.DUPLICATE_MLS_IDS error
		const apiError = this.props.companies.updatingExternalIdErrorId.find(user => user.userId === userId);
		if (_.get(apiError, 'errorId') === ERROR.DUPLICATE_MLS_IDS) {
			this.props.clearExternalIdState();
		}
	}

	cleanMlsIdValue(val) {
		return val.toString().trim();
	}

	isMlsIdAlreadyUsed(id) {
		let result = false;
		if (id === '') return result;

		const newExternalIds = this.state.newExternalIds;
		Object.keys(newExternalIds).forEach((currentUserId) => {
			if (_.isArray(newExternalIds[currentUserId]) && newExternalIds[currentUserId].includes(id)) {
				result = true;
			}
		});

		return result;
	}

	validateMlsId(value, userId, index) {

		const val = value.toString();
		const isIdAlreadyUsed = this.isMlsIdAlreadyUsed(val);
		if (val === '' || this.cleanMlsIdValue(val) === val && !isIdAlreadyUsed) {
			const mlsFieldsWithErrors = _.clone(this.state.mlsFieldsWithErrors);
			if (_.get(this.state.mlsFieldsWithErrors, `[${userId}][${index}]`)) {
				delete mlsFieldsWithErrors[userId][index];
			}
			
			this.setState({ mlsFieldsWithErrors });
			return true;
		} else {

			const mlsFieldsWithErrors = _.clone(this.state.mlsFieldsWithErrors);
			if (!mlsFieldsWithErrors[userId]) {
				mlsFieldsWithErrors[userId] = {};
			}
			mlsFieldsWithErrors[userId][index] = isIdAlreadyUsed
				?
				invalidMLSInputValue['already-used']
				:
				invalidMLSInputValue['invalid-value'] ;
			this.setState({ mlsFieldsWithErrors });

			return false;
		}		
	}

	isMLSSaveEnabled(userId, index) {
		const { users } = this.state;
		const originalUser = users.find(user => user.userId === userId);
		const originalExteralIds = originalUser.externalIds;
		const externalId = this.state.newExternalIds[userId][index];

		const fieldHasError = _.get(this.state.mlsFieldsWithErrors, `[${userId}][${index}]`);
		if (fieldHasError) {
			return false;
		}

		if (this.cleanMlsIdValue(externalId).length === 0) {
			return !_.isEmpty(originalExteralIds);
		}

		return _.isEmpty(_.get(originalExteralIds, `[${index}]`)) || originalExteralIds[index] !== externalId;
	}

	isMLSAddFieldEnabled(userId, index) {
		const { users } = this.state;
		const originalUser = users.find(user => user.userId === userId);
		const originalExteralIds = originalUser.externalIds;
		
		const externalId = this.state.newExternalIds[userId][index];

		if (this.cleanMlsIdValue(externalId).length === 0 && _.isEmpty(_.get(originalExteralIds, `[${index}]`))) {
			// default empty field
			return false;
		} else if (this.cleanMlsIdValue(externalId).length > 0 && _.isEmpty(_.get(originalExteralIds, `[${index}]`))) {
			// new empty field which was not saved
			return false;
		}

		return true;
	}

	onMLSFieldKeyPress(event, userId, index) {
		if (event.key === 'Enter') {
			if (!this.isMLSSaveEnabled(userId, index)) return;

			const value = this.state.newExternalIds[userId][index];
			const newExternalIds = _.clone(this.state.newExternalIds);
			newExternalIds[userId][index] = value;
	
			this.setState({ newExternalIds }, () => {
				this.updateExternalIdsForUser(userId, index);
			});
		}
	}

	resetPreviousAPIMessageFieldValue(exceptUserId, exceptIndex) {
		if (this.props.companies.updatingExternalIdErrorId.length) {
			// clear any previous error message from API field
			const users = this.getCompanyUsers();
			const newExternalIds = _.clone(this.state.newExternalIds);
			const shownMlsFields = _.clone(this.state.shownMlsFields);
			
			let fousedFieldHasChanged = false;
			Object.keys(newExternalIds).map(currentUserId => {
				
				const apiError = this.props.companies.updatingExternalIdErrorId.find(user => user.userId === currentUserId);
				if (apiError) {
					const user = users.find(u => u.userId === currentUserId);
					Object.keys(newExternalIds[currentUserId]).map(currentUserIndex => {

						const originalExternalIdsValue = _.get(user, `externalIds[${currentUserIndex}]`) || '';

						if (!exceptUserId && !exceptIndex || exceptUserId !== currentUserId ||
							(exceptUserId === currentUserId && parseInt(currentUserIndex) !== parseInt(exceptIndex))) {
							newExternalIds[currentUserId][currentUserIndex] = originalExternalIdsValue;
						}

						// don't clear error message if field with error is focused
						if (exceptUserId && exceptUserId === currentUserId &&
							parseInt(currentUserIndex) === parseInt(exceptIndex)) {

							if (!_.isEqual(originalExternalIdsValue, newExternalIds[currentUserId][currentUserIndex])) {
								fousedFieldHasChanged = true;
							}
						}						

						if (!exceptUserId && !exceptIndex || exceptUserId !== currentUserId ||
							(exceptUserId === currentUserId && parseInt(currentUserIndex) !== parseInt(exceptIndex))) {
	
							if (!_.get(this.state.focusedField, `[${currentUserId}][${currentUserIndex}]`)) {
								// ignore focusedField here as it will be updated
								// in hideAllMlsFields() > resetLastFocusedMLSField() chain
								const currentUserTotalIds = Object.keys(newExternalIds[currentUserId]).length;
	
								if (currentUserIndex > 0 &&
									currentUserIndex == currentUserTotalIds -1 &&
									_.isEmpty(originalExternalIdsValue)
								) {
									// remove last empty when added with Add new button
									delete shownMlsFields[currentUserId][currentUserIndex];
									newExternalIds[currentUserId].pop();
								} 							
	
							}
						}						
					});
					
				}
			});

			this.setState({ newExternalIds, shownMlsFields });

			if (!exceptUserId || !fousedFieldHasChanged) {
				this.props.clearExternalIdState();
			}
		}
		
	}

	onMLSFieldFocus(userId, index) {
		if (_.get(this.state.focusedField, `[${userId}][${index}]`)) return;

		if (!_.isEmpty(this.state.focusedField)) {
			this.resetLastFocusedMLSField(true, true);
		} else {
			this.resetPreviousAPIMessageFieldValue(userId, index);
		}
		
		const focusedField = {};
		focusedField[userId] = {};
		focusedField[userId][index] = true;
		this.setState({ focusedField });
	}

	onMLSFieldBlur(event) {
		if (event.key === 'Tab') {
			this.hideAllMlsFields(true);
		}
	}

	hideAllMlsFields(reset) {
		const shownMlsFields = _.clone(this.state.shownMlsFields);

		Object.keys(shownMlsFields).map(currentUserId => {
			Object.keys(shownMlsFields[currentUserId]).map(currentUserIndex => {
				if (!_.get(this.state.focusedField, `[${currentUserId}][${currentUserIndex}]`)) {
					delete shownMlsFields[currentUserId][currentUserIndex];
				}
			});
		});

		this.setState({shownMlsFields});
		reset && this.resetLastFocusedMLSField(true, true);
	}

	resetLastFocusedMLSField(resetPreviousAPIMessageField, clearExternalIdState) {
		resetPreviousAPIMessageField && this.resetPreviousAPIMessageFieldValue();

		const focusedField = _.clone(this.state.focusedField);
		const users = this.getCompanyUsers();

		Object.keys(focusedField).map(currentUserId => {
			Object.keys(focusedField[currentUserId]).map(currentUserIndex => {
				if (_.get(this.state.focusedField, `[${currentUserId}][${currentUserIndex}]`)) {
					delete focusedField[currentUserId][currentUserIndex];

					const shownMlsFields = _.clone(this.state.shownMlsFields);
					if (_.get(this.state.shownMlsFields, `[${currentUserId}][${currentUserIndex}]`)) {
						delete shownMlsFields[currentUserId][currentUserIndex];
					}

					const mlsFieldsWithErrors = _.clone(this.state.mlsFieldsWithErrors);

					const user = users.find(u => u.userId === currentUserId);
					const originalExternalIdsValue = _.get(user, `externalIds[${currentUserIndex}]`) || '';
					const newExternalIds = _.clone(this.state.newExternalIds);
					const currentUserTotalIds = Object.keys(newExternalIds[currentUserId]).length;

					if (currentUserIndex > 0 &&
						currentUserIndex == currentUserTotalIds -1 &&
						_.isEmpty(originalExternalIdsValue)
					) {
						// remove last empty when added with Add new button
						newExternalIds[currentUserId].pop();
						delete shownMlsFields[currentUserId][currentUserIndex];

					} else {
						newExternalIds[currentUserId][currentUserIndex] = originalExternalIdsValue;
					}

					if (_.get(this.state.mlsFieldsWithErrors, `[${currentUserId}][${currentUserIndex}]`)) {
						delete mlsFieldsWithErrors[currentUserId][currentUserIndex];
					}					

					this.setState({ newExternalIds, focusedField, shownMlsFields, mlsFieldsWithErrors });
				}			
			});
		});

		clearExternalIdState && this.props.clearExternalIdState();

	}
	
	updateExternalIdsForUser(userId, index) {
		const { users } = this.state;
		const updateUser = users.find(user => user.userId === userId);
		const originalExteralIds = updateUser.externalIds;
		const newExternalIds = _.clone(this.state.newExternalIds);
		
		// Delete empty MLS fields
		if (_.isArray(updateUser.externalIds) &&
			_.isArray(this.state.newExternalIds[userId]) &&
			this.state.newExternalIds[userId].length > updateUser.externalIds.length) {

			const delIdIndex = [];
			const nonEmptyValues = [];

			this.state.newExternalIds[userId].forEach((id, index) => {
				if (this.cleanMlsIdValue(id).length === 0) {
					delIdIndex.push(index);
				} else {
					nonEmptyValues.push(id);
				}
			});
			
			newExternalIds[userId] = nonEmptyValues.length ? nonEmptyValues : [''];
			this.setState({ newExternalIds });		

			if (delIdIndex.length) {
				const shownMlsFields = _.clone(this.state.shownMlsFields);
				const mlsFieldsWithErrors = _.clone(this.state.mlsFieldsWithErrors);
				const focusedField = _.clone(this.state.focusedField);
				delIdIndex.forEach((indexToDelete) => {
					if (_.get(this.state.shownMlsFields, `[${userId}][${indexToDelete}]`)) {
						delete shownMlsFields[userId][indexToDelete];
					}
					if (_.get(this.state.focusedField, `[${userId}][${indexToDelete}]`)) {
						delete focusedField[userId][indexToDelete];
					}					
					if (_.get(this.state.mlsFieldsWithErrors, `[${userId}][${indexToDelete}]`)) {
						delete mlsFieldsWithErrors[userId][indexToDelete];
					}
				});
				this.setState({ shownMlsFields, mlsFieldsWithErrors, focusedField });
			}
		}

		// Send PATCH request if externalIds value changed
		if (!_.isEqual(originalExteralIds, newExternalIds[userId])) {
			const updatingMlsIdForUsers = _.clone(this.state.updatingMlsIdForUsers);

			if (!updatingMlsIdForUsers[userId]) {
				updatingMlsIdForUsers[userId] = {};
			}
			updatingMlsIdForUsers[userId][index] = true;
			this.setState({ updatingMlsIdForUsers, focusedField: {} });

			this.props.updateUserExternalId(
				this.props.selectedCompanyId,
				userId,
				_.without(newExternalIds[userId], '', null, undefined)
			);
		}
	}

	getCompanyUsers() {
		const { rawDataById, selectedId } = this.props.companies;
		const company = rawDataById[selectedId];
		const { users } = company;
		return users;
	}

	getUserIdForEmail(email) {
		const users = this.getCompanyUsers();
		const user = users.find(u => u.email === email);
		const { userId } = user;
		return userId;
	}

	clearExternalIdsStateAfterRoleChange() {
		this.props.clearExternalIdState();
	}

	clearExternalIdsForUser(userId) {
		const users = this.getCompanyUsers();
		const user = users.find(u => u.userId === userId);
				
		if (userId && !_.isEmpty(user.externalIds)) {
			const updatingMlsIdForUsers = _.clone(this.state.updatingMlsIdForUsers);
			if (_.get(this.state.updatingMlsIdForUsers, `[${userId}]`)) {
				delete updatingMlsIdForUsers[userId];
			}
			
			const shownMlsFields = _.clone(this.state.shownMlsFields);
			if (_.get(this.state.shownMlsFields, `[${userId}]`)) {
				delete shownMlsFields[userId];
			}

			const focusedField = _.clone(this.state.focusedField);
			if (_.get(this.state.focusedField, `[${userId}]`)) {
				delete focusedField[userId];
			}

			const mlsFieldsWithErrors = _.clone(this.state.mlsFieldsWithErrors);
			if (_.get(this.state.mlsFieldsWithErrors, `[${userId}]`)) {
				delete mlsFieldsWithErrors[userId];
			}

			this.setState({ shownMlsFields, focusedField, updatingMlsIdForUsers, mlsFieldsWithErrors });
		}
	}

	isBulkAddedUser(user) {
		return user.userId && user.inviteCounter === 0 && user.email !== this.state.company.email;
	}

	renderUserRows(renderRoles, usersToRender, showMlsIdColumn, showUserPhoto, externalIds) {
		const { classes } = this.props;
		const { currentUserEmail } = this.props;

		return usersToRender.map((user, index) => {
			let { name, email, role, userId, profilePhotoUri } = encodeUser(user);
			const key = `user-row-${index}`;
			const refId = userId; // make refId equal user id as we need a unique identifier of the table row
			this.photoPickerRefs[refId] = React.createRef();
			!userId && (name = localize('user-table-username-pending-prompt'));
			const { plan } = convertPlanIdIntoSubscription(this.props.currentPlanId);
			const companyCreator = email === this.state.company.email;
			const showNoInvitationSign = userId && user.role !== USER_ROLE_GUEST && !companyCreator &&
				currentUserEmail !== email && !user.lastSessionTime && !user.inviteCounter;

			return (
				<Fade in={true} key={key}>
					<TableRow 
						hover
						className={classNames({
							[classes.tableBodyRow]: true,
							// show longer fade in for userRow when user is moved from member/admin table to members table
							['transtionsEnabled']: this.state.willChangeRole
						})}
					>
						<TableCell padding='dense' className={classes.tableCellBody}>
							{(currentUserEmail === email) ? localize('users-table-name-you', name) : name}
						</TableCell>
						{!userId && showUserPhoto && (
							<TableCell padding='dense' className={`${classes.tableCellBody} ${classes.photoCell}`}>


								<Tooltip
									placement="top"
									title={
										<Fragment>
											<Typography
												variant='body2'
												className={classNames(classes.infoTooltipText)}>
												{localize('user-table-photo-pending-prompt')}
											</Typography>
											<span className={classes.tooltipArrow} />
										</Fragment>
									}
									classes={{
										tooltip: classes.infoTooltip
									}}
								>
									<DefaultAvatar className={classes.avatarPlaceholder}/>
								</Tooltip>								
							</TableCell>
						)}
						{userId && showUserPhoto && (
							<TableCell padding='dense' className={classes.tableCellBody}>
								<SmartFieldPhotoPicker
									defaultPhoto={<DefaultAvatar className={classes.defaultAvatar}/>}
									photoUrlOrFile={profilePhotoUri || ''}
									onSelectPhoto={() => this.handleOpenPhotoPicker(refId)}
									onCropPhoto={() => profilePhotoUri && this.handleOpenPhotoCropper(refId, profilePhotoUri)}
									onRemovePhoto={() => this.handleRemovePhoto(userId)}
									showProgress={this.state.loadingPhotoUserId === userId}
								>
								</SmartFieldPhotoPicker>
								<input
									style={{ display: 'none' }}
									ref={this.photoPickerRefs[refId]}
									type="file"
									accept=".png,.jpg,.jpeg"
									multiple
									onChange={(e) => this.onPhotoAdd(e, { name, email, role, userId, profilePhotoUri })}
								/>
							</TableCell>
						)}
						
						<TableCell padding='dense' className={classes.tableCellBody}>
							{showNoInvitationSign ? (
								<div>
									<div className={classes.pendingSign}>
										{localize('user-type-no-invitation')}
									</div>
									<div>{email}</div>
								</div>
							) : email}
						</TableCell>
						{showMlsIdColumn && this.renderMLSCell(userId, externalIds[userId])}
						<TableCell padding='none' className={classes.tableCellBody}>
							<Select
								id={`select-current-user-role-${index}`}
								data-tid={`select-current-user-role-${index}`}
								name={`editUser-${email}`}
								onChange={(event) => this.handleUserEdit(event.target.value, email, userId)}
								onClick={() => { showMlsIdColumn && this.hideAllMlsFields(true); }}
								className={classes.roleSelect}
								disableUnderline
								fullWidth
								IconComponent={SelectArrow}
								MenuProps={{ classes: { paper: classes.roleSelectItems } }}
								value={role}
								disabled={currentUserEmail === email || plan === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT}
							>
								{PERMISSION_ROLE.map(option => (
									<MenuItem key={option.key} value={option.value}>
										{option.value}
									</MenuItem>
								))}
							</Select>
						</TableCell>
						<TableCell align='right' padding='none'>
							{user.role === USER_ROLE_GUEST ? (
								<IconButton
									color='secondary'
									data-tid={`button-user-delete-${index}`}
									component='span'
									name={`deleteUser-${email}`}
									disabled={currentUserEmail === email}
									className={classes.iconDelete}
									onClick={() => this.onRemoveMember(
										this.handleUserDelete, { email: email, user: encodeUser(user) })
									}
									aria-label='Delete'>
									<DeleteIcon />
								</IconButton>
							) : (
								<IconButton
									color='primary'
									data-tid={`button-user-more-${index}`}
									component='span'
									disabled={currentUserEmail === email}
									className={classes.iconMore}
									onClick={(event) => this.handleMenuOpen(event, user)}
									aria-label='More'>
									<MoreIcon />
								</IconButton>
							)}
						</TableCell>
					</TableRow>
				</Fade>
			);
		}, this);
	}

	/**
	 * Render the inactive company message
	 */

	renderInactiveCompanyInformation(classes) {
		const { company: { hasActiveSubscription, hasTrial } } = this.state;
		const { perpetualAddons } = getSubscriptionsAndAddons(this.props.company);
		const { subscription: cancelledSubscription } = getSubscriptionsAndAddons (this.props.company, true);

		let hasCancelledSubscriptionForNewPlan = false;
		if (cancelledSubscription) {
			const { plan } = convertPlanIdIntoSubscription(cancelledSubscription.planId);
			if (Object.values(SUBSCRIPTION_PLAN).includes(plan)) {
				hasCancelledSubscriptionForNewPlan = true;
			}
		}

		const renderInactiveCompanyErrorMessage = () => (
			<Fragment>
				{localize('users-inactive-company-information-1')}  
				<Link
					component="button"
					className={classes.errorInactiveCompanyLink}
					onClick={() => {
						this.setState({
							redirectUrl: getRoute(SUBSCRIPTION, this.state.selectedId),
							preselectSubscriptionView: SUBSCRIPTION_VIEW.PURCHASE_OPTIONS
						});
					}}
				>{localize('users-inactive-company-information-2')}</Link>
				{
					hasCancelledSubscriptionForNewPlan && (
						<Fragment>
							{localize('users-inactive-company-information-3')}
							<Link
								component="button"
								className={classes.errorInactiveCompanyLink}
								onClick={() => {
									this.setState({
										redirectUrl: getRoute(SUBSCRIPTION, this.state.selectedId),
										preselectSubscriptionView: SUBSCRIPTION_VIEW.CURRENT_PRODUCTS,
										preselectOpenCBDetails: true
									});
								}}					
							>
								{localize('users-inactive-company-information-4')}
							</Link>
						</Fragment>
					)
				}
				{localize('users-inactive-company-information-5')}
			</Fragment>
		);
	
		return hasActiveSubscription || hasTrial || !_.isEmpty(perpetualAddons)
			?
			null
			:
			<Typography
				className={classes.errorInactiveCompany}
				data-tid="company-error-messages">
				{renderInactiveCompanyErrorMessage()}
			</Typography>
		;
	}

	/**
	 * Triggers when number of company's memeber is reduced
	 * @param {*} callback Method, which should be executed on confirm
	 * @param {object} params { parameter: value} list
	 * @memberof Users
	 */
	onRemoveMember(callback, params) {
		this.props.showModal('CONFIRMATION_MODAL', {
			message: localize('users-remove-member-confirmation', params.email),
			buttons: [
				<Button
					key='button-cancel'
					variant='outlined'
					color='primary'
				>
					{localize('no')}
				</Button>,
				<Button
					key='button-confirm'
					variant='contained'
					color='primary'
					onClick={() => callback(params)}
				>
					{localize('yes')}
				</Button>
			]
		});
	}

	changeUserRole(params) {

		const { email, updatedUser } = params;
		const userId = updatedUser.userId;

		const previousUser = this.state.users.find(user => user.email === email);

		const users = this.state.users.map(user => {
			return user.email === email ? updatedUser : user;
		});
		const paidUsersNumber = this.state.users.filter(user => user.role !== USER_ROLE_GUEST).length;

		if (this.state.hasActiveSubscription) {

			this.props.estimateCostOnUpdateCompanyUser(users, updatedUser)
				.then((data) => {
					if (data instanceof AppError) {
						log.send(data);

						if (data.errorId === ERROR.API_REQUEST_LIMIT_EXCEEDED) {
							this.props.showRateLimitError();
						}

						return;
					}

					const { amount, currency, taxRate } = data.result;
					if (amount) {
						const { symbol = '' } = _.find(CURRENCIES, { key: currency.toLowerCase() }) || {};
						let message = `${localize('users-increase-confirm',
						[paidUsersNumber, paidUsersNumber + 1, symbol, amount / 100])}`;

						if (taxRate !== null) {
							message+= ` (${localize('subscription-including-vat')})`;
						}						

						this.showConfirmationPopup(message)
							.then(() => {
								this.props.updateCompanyUser(users, updatedUser)
									.then((data) => {
										if (data instanceof AppError) {
											log.send(data);
					
											if (data.errorId === ERROR.API_REQUEST_LIMIT_EXCEEDED) {
												this.props.showRateLimitError();
											}
										} else {
											trackUserEdit(
												encodeUser(previousUser),
												encodeUser(updatedUser),
												getTrackingOptions(this.props.company)
											);

											if (params.removeExternalIds) {
												this.clearExternalIdsForUser(userId);
											} else if (params.clearExternalIdsState) {
												this.clearExternalIdsStateAfterRoleChange(userId);
											}
										}
									});
							})
							.catch(() => {
								// silent catch
							});
					} else {
						this.props.updateCompanyUser(users, updatedUser)
							.then((data) => {
								if (data instanceof AppError) {
									log.send(data);

									if (data.errorId === ERROR.API_REQUEST_LIMIT_EXCEEDED) {
										this.props.showRateLimitError();
									}
								} else {
									trackUserEdit(
										encodeUser(previousUser),
										encodeUser(updatedUser),
										getTrackingOptions(this.props.company)
									);

									if (params.removeExternalIds) {
										this.clearExternalIdsForUser(userId);
									} else if (params.clearExternalIdsState) {
										this.clearExternalIdsStateAfterRoleChange(userId);
									}	
								}
							});						
						
					}
				});
		} else {
			this.props.updateCompanyUser(users, updatedUser)
				.then((data) => {
					if (data instanceof AppError) {
						log.send(data);

						if (data.errorId === ERROR.API_REQUEST_LIMIT_EXCEEDED) {
							this.props.showRateLimitError();
						}
					} else {
						trackUserEdit(encodeUser(previousUser), encodeUser(updatedUser), getTrackingOptions(this.props.company));
						if (params.removeExternalIds) {
							this.clearExternalIdsForUser(userId);
						} else if (params.clearExternalIdsState) {
							this.clearExternalIdsStateAfterRoleChange(userId);
						}
					}
				});				
		}
	}
	
	handleUserEdit(role, email, userId) {
		const updatedUser = decodeUser({ email, role, userId });

		const users = this.getCompanyUsers();
		const oldUserData = users.find(u => u.email === email);
		const { role: oldRole } = oldUserData;

		if (updatedUser.role === USER_ROLE_GUEST) {
			this.onRemoveMember(this.changeUserRole, { email, updatedUser, removeExternalIds: true });
		} else {
			this.setState({
				willChangeRole: true
			});
			this.changeUserRole({
				email,
				updatedUser,
				clearExternalIdsState: oldRole === USER_ROLE_GUEST && updatedUser.role !== USER_ROLE_GUEST
			});
		}
	}

	updateCompanyUser(users, updatedUser, previousUser) {
		this.props.updateCompanyUser(users, updatedUser)
			.then((data) => {
				if (data instanceof AppError) {
					log.send(data);

					if (data.errorId === ERROR.API_REQUEST_LIMIT_EXCEEDED) {
						this.props.showRateLimitError();
					}
				}
			});

	}

	handleUserDelete(params) {
		const { user } = params;
		trackUserDelete(user, getTrackingOptions(this.props.company));

		if (user) {
			this.props.deleteCompanyUser(user.email)
				.then((data) => {
					if (data instanceof AppError) {
						log.send(data);
	
						if (data.errorId === ERROR.API_REQUEST_LIMIT_EXCEEDED) {
							this.props.showRateLimitError();
						}
					}});			
		}
	}

	handleAddUsers(newUsers, companyInviteMessage) {
		let totalAvailableSeatsNumber = 0;
		let newTotalSeatsNumber = 0;
		const nonGuestUsers = filterNonGuestUsers(this.props.company.users);
		const hasPlan = this.props.currentPlanId !== undefined;

		const additionalUsersNumber = newUsers.filter(user => user.role !== USER_ROLE_GUEST).length;

		if (hasPlan) {
			const { plan } = convertPlanIdIntoSubscription(this.props.currentPlanId);
			totalAvailableSeatsNumber = PACKAGES_CONFIG[plan].freeSeatsIncluded + getMembersPaidQuantity(this.props.company);
			
			const areAllSeatsUsed = nonGuestUsers.length >= totalAvailableSeatsNumber;
			newTotalSeatsNumber = areAllSeatsUsed
				?
				totalAvailableSeatsNumber + additionalUsersNumber
				:
				nonGuestUsers.length + additionalUsersNumber;
		}

		if (this.state.hasActiveSubscription) {
			this.props.estimateCostOnAddCompanyUsers(newUsers)
				.then((data) => {
					if (data instanceof AppError) {
						// API_REQUEST_LIMIT_EXCEEDED error is shown inline, we don't have to trigger popup here
						return;
					}

					const { amount, currency, taxRate } = data.result;
					if (amount) {
						const { symbol = '' } = _.find(CURRENCIES, { key: currency.toLowerCase() }) || {};
						let message = `${localize('users-increase-confirm',
											[totalAvailableSeatsNumber, 
												newTotalSeatsNumber, 
												symbol, amount / 100])}`;

						if (taxRate !== null) {
							message+= ` (${localize('subscription-including-vat')})`;
						}

						this.showConfirmationPopup(message)
							.then(() => this.addCompanyUsersAndTrack(
								newUsers,
								newTotalSeatsNumber,
								companyInviteMessage))
							.catch(() => {
								// silent catch - no error logged

								// back to invitation popup
								this.handleShowAddUserModal();
							});
					} else {
						this.addCompanyUsersAndTrack(newUsers, newTotalSeatsNumber, companyInviteMessage);
					}
				});
		} else {
			this.addCompanyUsersAndTrack(newUsers, newTotalSeatsNumber, companyInviteMessage);
		}
	}

	handleSendInvitations() {
		const { users } = this.state;
		const usersToInvite = users.filter(user => [USER_ROLE_ADMIN, USER_ROLE_BASIC].includes(user.role) &&
			!user.lastSessionTime && user.email !== this.state.company.email && user.email !== this.props.currentUserEmail);
			// send emails to every user who hasn’t signed in
		
		const hasPlan = this.props.currentPlanId !== undefined;
		let totalAvailableSeatsNumber = 0;
		let newTotalSeatsNumber = 0;
		const nonGuestUsers = filterNonGuestUsers(this.props.company.users);
		const additionalUsersNumber = usersToInvite.length;

		if (hasPlan) {
			const { plan } = convertPlanIdIntoSubscription(this.props.currentPlanId);
			totalAvailableSeatsNumber = PACKAGES_CONFIG[plan].freeSeatsIncluded + getMembersPaidQuantity(this.props.company);
			
			const areAllSeatsUsed = nonGuestUsers.length >= totalAvailableSeatsNumber;
			newTotalSeatsNumber = areAllSeatsUsed
				?
				totalAvailableSeatsNumber + additionalUsersNumber
				:
				nonGuestUsers.length + additionalUsersNumber;
		}

		this.props.sendInviteToUsers(usersToInvite, null, hasPlan, newTotalSeatsNumber);
	}

	handleManageMlsAgents(userId, selfStartMlsIdsForUser = []) {
		const { connections } = this.props.mls;
		this.props.showModal('MANAGE_MLS_AGENTS_MODAL', { 
			connections,
			preselectUserId: userId,
			usersPage: true, 
			selfStartMlsIdsForUser,
			onClose: this.onManageMlsAgentsCloseHandler
		});
	}		

	onManageMlsAgentsCloseHandler() {
		this.props.clearConnectMlsState();
		this.props.hideModal();
	}

	handleShowAddUserModal(email, showApiError) {

		const errorId = this.props.companies.addCompanyUsersErrorId;
		const isUserLimitReachedError = showApiError && errorId === ERROR.USER_REACHED_THE_COMPANY_INVITATION_LIMIT;

		if (isUserLimitReachedError) {
			this.props.hideModal();
			this.props.showErrorPopup(ERROR.USER_REACHED_THE_COMPANY_INVITATION_LIMIT);
		} else {
			const { plan } = convertPlanIdIntoSubscription(this.props.currentPlanId);

			let allowedRoles;
			let upgradeInfoMessage;
			if (plan === SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT) {
				allowedRoles = [USER_ROLE_GUEST];
				upgradeInfoMessage = localize('re-upgrade-to-brokerage-to-add-more-users');
			}

			this.props.showModal('INVITE_USERS_MODAL', 
				{ 	email,
					handleAddUsers: this.handleAddUsers, 
					showApiError,
					allowedRoles,
					upgradeInfoMessage
				});
		}
	}

	addCompanyUsersAndTrack(users, newTotalSeatsNumber, companyInviteMessage) {
		const userDataFiltered = users.map(user => ({email: user.email, role: user.role}));
		const hasPlan = this.props.currentPlanId !== undefined;
		
		let targetUsersPayingQuantity;
		if (hasPlan) {
			targetUsersPayingQuantity = newTotalSeatsNumber;
		}

		this.props.addCompanyUsers(userDataFiltered, companyInviteMessage, hasPlan, targetUsersPayingQuantity)
			.then((data) => {
				if (data instanceof AppError) {
					this.handleShowAddUserModal(null, true);
					return;
				} else {
					this.props.hideModal();
				}
				
				trackUserAdd(users, getTrackingOptions(this.props.company));
				this.props.inviteUsersClearUsers();
				this.props.inviteUsersClearMessage();
			});
	}

	/**
	 * Show cost confirmation popup
	 *
	 * @param {string} message HTML message
	 * @param {string} actionButtonLabel a label on the action button
	 * @returns Promise
	 * @memberof Users
	 */
	showConfirmationPopup(message, actionButtonLabel = localize('pay-now')) {
		return new Promise((resolve, reject) => {
			this.props.showModal('CONFIRMATION_MODAL', {
				message: {
					__html: message
				},
				buttons: [
					<Button
						key='button-cancel'
						variant='outlined'
						color='primary'
						onClick={() => reject()}
					>
						{localize('cancel')}
					</Button>,
					<Button
						key='button-confirm'
						variant='contained'
						color='primary'
						onClick={() => resolve()}
					>
						{actionButtonLabel}
					</Button>
				]
			});
		});
	}

	showCompleteTeamProfileModal() {
		this.props.showModal('CONFIRMATION_MODAL', {
			message: { __html: localize('users-complete-team-profile') },
			buttons: [
				<Button
					key='button-confirm'
					variant='contained'
					color='primary'
					onClick={() => {
						this.setState({
							redirectUrl: getRoute(ROOT, this.state.selectedId)
						});
					}}
				>
					{localize('users-team-profile')}
				</Button>
			]
		});
	}
}

Users.propTypes = {
	classes: PropTypes.object,
	company: PropTypes.object,
	companies: PropTypes.object,
	currentUserEmail: PropTypes.string,
	auth: PropTypes.array,
	addCompanyUsers: PropTypes.func.isRequired,
	sendInviteToUsers: PropTypes.func.isRequired,
	updateCompanyUser: PropTypes.func.isRequired,
	deleteCompanyUser: PropTypes.func.isRequired,
	estimateCostOnAddCompanyUsers: PropTypes.func.isRequired,
	estimateCostOnUpdateCompanyUser: PropTypes.func.isRequired,
	estimateCostOnDeleteCompanyUser: PropTypes.func.isRequired,
	writeUserSettings: PropTypes.func.isRequired,
	showModal: PropTypes.func,
	hideModal: PropTypes.func,
	location: PropTypes.object,
	askToCompleteCompanyProfile: PropTypes.bool,
	settings: PropTypes.object,
	inviteUsersClearUsers: PropTypes.func,
	inviteUsersClearMessage: PropTypes.func,
	currentPlanId: PropTypes.string,
	showRateLimitError: PropTypes.func.isRequired,
	updateUserExternalId: PropTypes.func.isRequired,
	clearExternalIdState: PropTypes.func.isRequired,
	selectedCompanyId: PropTypes.string,
	showErrorPopup: PropTypes.func.isRequired,
	updateUserPhoto: PropTypes.func.isRequired,
	mls: PropTypes.object,
	clearConnectMlsState: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
	error: state.error,
	company: state.companies.rawDataById[state.companies.selectedId],
	auth: state.session.user.auth,
	companies: state.companies,
	currentUserEmail: state.session.user.mainEmail,
	currentPlanName: getCurrentPlanName(state.companies.rawDataById[state.companies.selectedId]),
	settings: state.session.user.settings,
	currentPlanId: getCurrentPlanId(state.companies.rawDataById[state.companies.selectedId]),
	selectedCompanyId: state.companies.selectedId,
	mls: state.mls
});

const mapDispatchToProps = dispatch => bindActionCreators({
	addCompanyUsers,
	sendInviteToUsers,
	updateCompanyUser,
	deleteCompanyUser,
	estimateCostOnAddCompanyUsers,
	estimateCostOnUpdateCompanyUser,
	estimateCostOnDeleteCompanyUser,
	writeUserSettings,
	showModal,
	hideModal,
	inviteUsersClearMessage,
	inviteUsersClearUsers,
	showRateLimitError,
	updateUserExternalId,
	clearExternalIdState,
	showErrorPopup,
	updateUserPhoto,
	clearConnectMlsState
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Users);


// WEBPACK FOOTER //
// ./src/containers/Users/Users.js